import type { IFileWrapper } from "./common/uploader/uploader-helpers";

export interface IDictionary<T> {
  [key: string]: T;
}

export enum MediaSize {
  TH = 320,
  ST = 600,
  RT = 1080,
  SR = 1440,
}

export interface IMediaLockConfigType {
  unlockText?: string | React.ReactNode;
  unlockButtonText?: string;
  unlockData?: IDictionary<any>;
}

export interface IMediaType {
  public_id?: string; // cloudinary public id
  media_id?: string; // bendinary media id
  th: string; // width 320px
  st?: string; // width 600px
  rt?: string; // width 1080px
  sr?: string; // width 1440px
  op?: string; // height 320px
  video_url?: string;
  video_length?: number;
  width?: number;
  height?: number;
  approved?: boolean;
  review_status?: string;
  score?: number;
  isLocked?: boolean; // custom
  isClientSideBlur?: boolean; // custom
  caption?: string; // from feed
  lockConfig?: IMediaLockConfigType;
  isClientSide?: boolean; // client side item
  uploadProgress?: number; // client side item
  loaded?: number; // client side item
  total?: number; // client side item
  abortUpload?: () => void; // client side item
}

export enum EPaymentType {
  Subscription = "Subscription",
  PackageSelect = "PackageSelect",
  ChatTip = "ChatTip",
  ChatPurchase = "ChatPurchase",
  FeedTip = "FeedTip",
}

// TODO: get rid of this and make use only of general Popup in the future
export enum EPopupSection {
  OnboardingPopup = "OnboardingPopup",
  PubnubPopup = "PubnubPopup",
  LandingPopup = "LandingPopup",
  ModelProfilePopup = "ModelProfilePopup",
  AccountPopup = "AccountPopup",
  MessengerPopup = "MessengerPopup",
  ChatPopup = "ChatPopup",
  DiscoverPopup = "DiscoverPopup",
  Popup = "Popup",
}

export interface IPopupWrapper {
  popup: IPopupConfig;
  popupSection: EPopupSection;
}

export enum EPopupAccountType {
  PopupDeleteImage = "PopupDeleteImage",
  PopupDeleteCreditCard = "PopupDeleteCreditCard",
  PopupDeleteCreditCardError = "PopupDeleteCreditCardError",
}

export enum EPopupChatType {
  PopupConfirmDeleteChats = "PopupConfirmDeleteChats",
  PopupConfirmHideChats = "PopupConfirmHideChats",
}

export enum EPopupDiscoverType {
  PopupBoost = "PopupBoost",
  PopupReferralProgram = "PopupReferralProgram",
  PopupReferralProgramUser = "PopupReferralProgramUser",
}

export enum EPopupMessengerType {
  PopupError = "PopupError",
  PopupNotEnoughCredits = "PopupNotEnoughCredits",
  PopupMessagingDisabled = "PopupMessagingDisabled",
  PopupUploadInProgress = "PopupUploadInProgress",
  PopupWarningPaymentUser = "PopupWarningPaymentUser",
  PopupWarningGlobalFM = "PopupWarningGlobalFM",
  PopupErrorMessageOptions = "PopupErrorMessageOptions",
}

export enum EPopupOnboardingType {
  PopupEmailVerifyUsingCode = "PopupEmailVerifyUsingCode",
  PopupEmailVerified = "PopupEmailVerified",
  PopupEssentialInfo = "PopupEssentialInfo",
  PopupAddInviteCode = "PopupAddInviteCode",
  PopupSelectGender = "PopupSelectGender",
}

export enum EPopupPubnubType {
  PayoutCompleted = "PayoutCompleted",
  AccountTerminated = "AccountTerminated",
}

export enum EPopupType {
  BasicClosePopup = "BasicClosePopup",
  BasicConfirmPopup = "BasicConfirmPopup",
  BasicEmptyPopup = "BasicEmptyPopup",
}

export interface IPopupConfig {
  id?: string; // optional unique id for the popup
  type:
    | EPopupDiscoverType
    | EPopupChatType
    | EPopupPubnubType
    | EPopupAccountType
    | EPopupMessengerType
    | EPopupOnboardingType
    | EPopupType;
  // TODO: highest blast radius in the codebase - this backs every popup in
  // the app (dozens of `type` variants across 6 enums), each expecting its
  // own props shape. Properly typing it needs a discriminated union keyed
  // by `type` mapping to each popup's own Props interface; not attempted
  // here since it touches every pushPopup()/popPopup() call site.
  props?: any;
}

export enum EMessageBubbleType {
  User = "User",
  OtherUser = "OtherUser",
  System = "System",
  SystemWarning = "SystemWarning",
  Tip = "Tip",
}

export enum EPaidContentPopupType {
  Messenger = "Messenger",
  AutoMessages = "AutoMessages",
  Broadcast = "Broadcast",
}

export interface IUploadQueue {
  id: string;
  filesToUpload: IFileWrapper[];
  uploadHandler: (mediaFileWrapper: IFileWrapper, callback: () => void) => void;
  onFileComplete?: (mediaFileWrapper: IFileWrapper) => void;
  onQueueComplete?: (id: string) => void;
  description: string;
}
